module.exports = __webpack_public_path__ + "static/img/brees-2001-top-image.5a69946.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/brees-2001-top-image.jpg
// module id = UoTx
// module chunks = 1